import { gql } from "@apollo/client";

// Subscripción que se activa cuando se recibe un nuevo mensaje de PMV
export const OnLastPMVMessage = gql`
    subscription OnLastPMVMessage {
        its_pmv_statuses(
            order_by: { created_at: desc }
            limit: 1
        ) {
            id
            message
            updated_at
            pmv_id
            is_online
        }
    }
`;